import React from 'react';
import { FaFileUpload } from "react-icons/fa";
import { MdDownload } from "react-icons/md";

import RangeSlider from './RangeSlider';

const CreateTilesContainer = ({ handleDownload, imageFile, open, setTileSize }) => {


  return (
    <section className="flex flex-col gap-2 absolute top-20 left-1/2 -translate-x-1/2 min-w-[600px] w-[80%] max-w-[900px] snap-start p-2 bg-white rounded-xl shadow-2xl max-[600px]:top-0 max-[600px]:w-full max-[600px]:min-w-[auto] max-[600px]:-translate-x-1/2 max-[600px]:translate-y-0">

      <nav className="flex flex-row gap-3 max-[740px]:flex-col max-[740px]:text-center">
        <div className="flex flex-col">
          <div className='text-2xl font-bold'>
            Seamless Tiling Pattern
          </div>
          <span>
            Create & check seamless tiles
          </span>
        </div>
        <div className="flex flex-grow items-center gap-2 text-gray-600  ">
          {/* File Upload button */}
          <button
            className="border rounded-md border-gray-400 w-12 h-12 flex items-center justify-center"
            onClick={open}
          >
            <FaFileUpload size={24} />
          </button>
          {/* Range Slider */}
          <RangeSlider setTileSize={setTileSize} />
          {/* Pattern Download button */}
          <button
            className={`border rounded-md border-gray-400 w-12 h-12 flex items-center justify-center ${!imageFile ? 'text-gray-300 hover:cursor-not-allowed' : 'hover:cursor-pointer'}`}
            disabled={!imageFile}
            onClick={handleDownload}
          >
            <MdDownload size={26} />
          </button>
        </div>
      </nav>
      {
       
        !imageFile && (
          <div className="text-gray-200 bg-gray-700 rounded-md p-3 shadow-inner">
            <h3 className='text-lg mb-1'>
              Image file input options:
            </h3>
            <ol className='list-disc list-inside'>
              <li>Click on the File button to select a local image</li>
              <li>Drag and drop image from local file anywhere on the screen</li>

            </ol>

          </div>
        )
      }



    </section>
  )
}

export default CreateTilesContainer